export default __webpack_public_path__ + "static/media/TrovityImage.b6fc258a.svg";